import { useState } from "react";
import { projectURL } from "./utils/mockdata";
import { Eye, EyeOff } from "lucide-react";
import Modal from "./Modal";

const Register = () => {
  const [username, setUsername] = useState();
  const [userEmail, setUserEmail] = useState();
  const [password, setPassword] = useState();
  const [gender, setGender] = useState();

  const [isVisible, setIsVisible] = useState(false);
  const [loading, setLoading] = useState(false); // ✅ Loader state

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalTitle, setModalTitle] = useState('');
  const [modalType, setModalType] = useState("info");

  const toggleVisibility = () => setIsVisible((prevState) => !prevState);

  const handleRegister = async (e) => {
    e.preventDefault();

    if (!username || !userEmail || !password || !gender) {
      setModalTitle("Missing Fields");
      setModalMessage("Kindly enter all fields to register your profile.");
      setModalType("info");
      setIsModalOpen(true);
      return;
    }

    const dataInput = {
      username,
      email: userEmail,
      password,
      gender,
      imagePath: "https://cdn-icons-png.flaticon.com/128/11461/11461171.png",
    };

    const registerPath = projectURL + "profiles/register";

    setLoading(true); // ✅ Start loader

    try {
      const res = await fetch(registerPath, {
        headers: {
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify(dataInput),
      });
      const resData = await res.json();
      console.log("res status", res.status, resData);

      if (res.ok) {
        const userId = resData._id;
        const userImage = resData.imagePath;

        sessionStorage.setItem("authenticated", true);
        sessionStorage.setItem("loggedUserName", username);
        sessionStorage.setItem("loggedUserId", userId);
        sessionStorage.setItem('loggedInUserImage', userImage);

        setModalTitle("Welcome");
        setModalMessage(`Welcome 😃 ${username}, you have logged in !`);
        setModalType("info");
        setIsModalOpen(true);

        setTimeout(() => {
          setIsModalOpen(false);
          window.location.href = '/profile';
        }, 2000);
      } else {
        if (res.status === 400) {
          setModalTitle("Error");
          setModalMessage("👤 Username or 📧 Email address already exists use Unique.");
          setModalType("error");
          setIsModalOpen(true);
        } else {
          setModalTitle("Error");
          setModalMessage("An unexpected error occurred. Please try again later.");
          setModalType("error");
          setIsModalOpen(true);
        }

        setTimeout(() => {
          setIsModalOpen(false);
        }, 6000);

      }
    } catch (error) {
      setModalTitle("Error");
      setModalMessage(`An error occurred during registration.`);
      setModalType("error");
      setIsModalOpen(true);
    } finally {
      setLoading(false); // ✅ Stop loader
    }
  };

  return (
    <div>
      <div className="max-w-md mx-auto mt-20 p-6 bg-white rounded-2xl shadow-xl border-2 border-gray-200">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm">
          {/* <img className="max-w-30" src="socio1-3d.png" alt="Your Company" /> */}
          <div className="flex justify-center space-x-2">
            <div className="w-8 h-8 flex items-center justify-center">
              <img className="ring-2 ring-blue max-w-10 w-8 border rounded-full p-1.5" src="icon.jpg" alt="Socio" />
            </div>
            <span className="text-2xl font-bold bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent">
              Socio
            </span>
          </div>
          <h2 className="mt-6 text-center text-2xl/5 font-bold tracking-tight text-gray-900">
            Sign up to your account
          </h2>
        </div>

        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
          <form className="space-y-6" onSubmit={handleRegister}>
            <div>
              <div className="mt-2">
                <input
                  placeholder="Enter Username"
                  onChange={(e) => setUsername(e.target.value)}
                  value={username}
                  id="username"
                  name="username"
                  type="text"
                  required
                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-center focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6 p-2"
                />
              </div>
            </div>

            <div>
              <div className="mt-2">
                <select id="gender"
                  onChange={(e) => setGender(e.target.value)}
                  name="gender"
                  required
                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-center focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6 p-2">
                  <option className="text-center" value="" disabled selected> Select Gender </option>
                  <option className="text-left" value="Male">Male</option>
                  <option className="text-left" value="Female">Female</option>
                  <option className="text-left" value="Other">Other</option>
                </select>
              </div>
            </div>

            <div>
              <div className="mt-2">
                <input
                  placeholder="Enter Email"
                  onChange={(e) => setUserEmail(e.target.value)}
                  value={userEmail}
                  id="email"
                  name="email"
                  type="email"
                  required
                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-center focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6 p-2"
                />
              </div>
            </div>

            <div>
              <div className="mt-2">
                <div className="relative">
                  <input
                    onChange={(e) => setPassword(e.target.value)}
                    id="password"
                    type={isVisible ? "text" : "password"}
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-center focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6 p-2"
                    placeholder="Enter Password"
                    aria-label="Password"
                    required
                  />
                  <button
                    className="absolute inset-y-0 end-0 flex items-center z-20 px-2.5 cursor-pointer text-gray-400 rounded-e-md focus:outline-none focus-visible:text-indigo-500 hover:text-indigo-500 transition-colors"
                    type="button"
                    onClick={toggleVisibility}
                    aria-label={isVisible ? "Hide password" : "Show password"}
                    aria-pressed={isVisible}
                    aria-controls="password"
                  >
                    {isVisible ? <EyeOff size={20} /> : <Eye size={20} />}
                  </button>
                </div>
              </div>
            </div>

            <a
              href="login"
              className="underline text-blue-600 hover:text-blue-800 visited:text-purple-600"
            >
              Login Here
            </a>

            <div>
              <button
                type="submit"
                disabled={loading}
                className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm/6 font-semibold text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-full text-sm px-5 py-2.5 text-center"
              >
                {loading && (
                  <svg
                    className="animate-spin h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    />
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                    />
                  </svg>
                )}
                {loading ? "Registering..." : "Sign up"}
              </button>
            </div>
          </form>
        </div>
      </div>

      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={modalTitle}
        message={modalMessage}
        type={modalType}
      />
    </div>
  );
};

export default Register;
